<script>
export default {
  name: 'SignatureStatusBadge',
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    statusLabel() {
      return this.$ecTranslate(`ELIXIO_CONNECT.${this.status}`)
    },
    statusClass() {
      const map = {
        DRAFT: 'draft',
        CREATED: 'draft',
        UPDATED: 'draft',
        SENT: 'sent',
        COMPLETED: 'completed',
        DECLINED: 'declined',
        EXPIRED: 'declined',
        DELETED: 'deleted',
      }
      return map[this.status] || 'draft'
    },
  },
}
</script>

<template>
  <span class="ec-status-pill" :class="`ec-status-pill--${statusClass}`">
    {{ statusLabel }}
  </span>
</template>

<style scoped>
.ec-status-pill {
  display: inline-flex;
  align-items: center;
  padding: 0.25em 0.85em;
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1.4;
  white-space: nowrap;
  border-radius: 50rem;
  border: 1px solid;
}

.ec-status-pill--draft {
  color: #6b7280;
  background-color: #f3f4f6;
  border-color: #d1d5db;
}

.ec-status-pill--sent {
  color: #2563eb;
  background-color: #eff6ff;
  border-color: #93c5fd;
}

.ec-status-pill--completed {
  color: #16a34a;
  background-color: #f0fdf4;
  border-color: #86efac;
}

.ec-status-pill--declined {
  color: #dc2626;
  background-color: #fef2f2;
  border-color: #fca5a5;
}

.ec-status-pill--deleted {
  color: #4b5563;
  background-color: #f3f4f6;
  border-color: #9ca3af;
}
</style>
